import * as React from "react";
import { Box, Typography } from "@mui/material";
import {
  platformStatCardSx,
  platformStatLabelSx,
  platformStatValueSx,
  platformFonts,
  usePlatformColors,
} from "../tickitPlatformTheme";

export function PlatformStatsGrid({ children, columns = 4 }) {
  const cols =
    columns === 3
      ? { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }
      : { xs: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" };
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: cols,
        gap: 1.75,
        mb: 2.75,
      }}
    >
      {children}
    </Box>
  );
}

export default function PlatformStatCard({ label, value, delta, deltaTone, icon, iconBg, iconColor }) {
  const colors = usePlatformColors();
  return (
    <Box sx={platformStatCardSx}>
      {icon && (
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1.5,
            backgroundColor: iconBg || colors.brandPale,
            color: iconColor || colors.brand,
            "& .MuiSvgIcon-root": { fontSize: 20 },
          }}
        >
          {icon}
        </Box>
      )}
      <Typography sx={platformStatLabelSx}>{label}</Typography>
      <Typography sx={{ ...platformStatValueSx, mt: 1, fontSize: { xs: "1.5rem", sm: "1.75rem" } }}>{value}</Typography>
      {delta && (
        <Typography
          sx={{
            fontFamily: platformFonts.body,
            fontSize: "0.75rem",
            fontWeight: 600,
            mt: 0.75,
            color: deltaTone === "down" ? colors.danger : colors.success,
          }}
        >
          {delta}
        </Typography>
      )}
    </Box>
  );
}
